import { useState } from "react";
import { SelectUploadImageContext } from "./context";
import { SelectUploadImageHandlers } from "./types";

export interface SelectUploadImageProviderProps {
  defaultHandlers?: SelectUploadImageHandlers;
  children?: React.ReactNode;
}

const defaultHandlers = {
  onUpload: () => undefined,
};

export function SelectUploadImageProvider({
  defaultHandlers: defaultHandlersProp,
  children,
}: SelectUploadImageProviderProps) {
  const [handlers, updateHandlers] = useState<SelectUploadImageHandlers>(
    defaultHandlersProp || defaultHandlers
  );

  return (
    <SelectUploadImageContext.Provider
      value={{
        updateHandlers,
        handlers,
      }}
    >
      {children}
    </SelectUploadImageContext.Provider>
  );
}
